import RendererTypesEnum from '~/modules/catalog/category/components/filters/renderer/RendererTypesEnum';
import config, { FilterTypeEnum } from './config';
import { isArray, isEmpty } from 'lodash-es';

export interface FilterConfigInterface {
  attrCode: string;
  component?: RendererTypesEnum;
  type?: FilterTypeEnum;
  disabled?: boolean
  notSearch?: boolean
}

export const getFilterConfig = (attrCode: string): FilterConfigInterface => {
  const defaultCfg = {
    attrCode,
    type: FilterTypeEnum.CHECKBOX,
    component: RendererTypesEnum.CHECKBOX,
    disabled: false,
  };

  const find = config().find((cfgItem) => cfgItem.attrCode === attrCode) ?? {};
  return { ...defaultCfg, ...find };
};

export const getDisabledFilters = () => config().filter((filter) => filter.disabled).map((filter) => filter.attrCode);
export const isFilterEnabled = (attrCode: string) => config().find((attr) => attr.attrCode === attrCode && !attr.disabled);
export const isFilterEnabledForSearch = (attrCode: string) => config().find((attr) => attr.attrCode === attrCode && !attr.disabled && !attr.notSearch);
export const isFilterEnabledInCategory = (ids: string[] | null, category_uid: string) => {
  
  /**
   * @TODO: Fix magento response to simplify logic:
   * Null if empty, array with values separated.
   */

  if (isArray(ids) && isEmpty(ids)) return true;
  return !isEmpty(ids) && ids[0].includes(category_uid) ? true : false;
}